import { combineReducers } from 'redux';
import auth from './auth';
import navigation from './navigation';
import alerts from './alerts';
import register from './register';
import {i18nState} from 'redux-i18n';

export default combineReducers({
  alerts,
  auth,
  i18nState,
  navigation,
  register,
});
